// src/App.js
import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './Views/HomePage';

// These will be placeholder components until you create the actual pages
const ThermalsPage = () => <div><h1>Thermals Page</h1><p>Content coming soon</p></div>;
const NightVisionPage = () => <div><h1>Night Vision Page</h1><p>Content coming soon</p></div>;
const PricingPage = () => <div><h1>Pricing Page</h1><p>Content coming soon</p></div>;
const AboutPage = () => <div><h1>About Us Page</h1><p>Content coming soon</p></div>;

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/thermals" element={<ThermalsPage />} />
          <Route path="/night-vision" element={<NightVisionPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/about" element={<AboutPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;